import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useEmail, useUserId } from '../state/auth';
import { useCurrentClinic } from './useCurrentClinic';

// useSetPosthogIdentify is a hook that sets the PostHog identify context for the user. This will allow us to target
// analytics events to specific users and/or clinics.  More information on setting up PostHog identify can be found
// here: https://posthog.com/docs/libraries/react#using-posthog-js-functions
export const useSetPosthogIdentify = () => {
  const posthog = usePostHog();
  const email = useEmail();
  const userId = useUserId();
  const { clinic, isPending } = useCurrentClinic();

  useEffect(() => {
    if (posthog && userId) {
      posthog.identify(userId, {
        email: email
      });
    }
  }, [posthog, userId, email, clinic]);

  useEffect(() => {
    if (posthog && clinic && !isPending) {
      // Send group event to PostHog to identify the clinic.  Beyond analytics, this is used to target feature flags
      // to specific clinics.
      posthog.group('clinic', clinic.id, { name: clinic.name });
      posthog.capture('clinic_identified');
    }
  }, [clinic, isPending]);
};
